/**
 * GenerateBar — input for choosing post count and triggering generation
 */

import { useState } from 'react';
import { Button } from '@lib/ui';

interface GenerateBarProps {
  isGenerating: boolean;
  isStarting: boolean;
  error: string | null;
  onGenerate: (count: number) => void;
}

export function GenerateBar({ isGenerating, isStarting, error, onGenerate }: GenerateBarProps) {
  const [count, setCount] = useState(10);

  const disabled = isGenerating || isStarting;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
      <div className="flex items-center gap-2">
        <label
          htmlFor="post-count"
          className="text-sm font-medium text-gray-700 dark:text-dark-200 whitespace-nowrap"
        >
          Posts to generate
        </label>
        <input
          id="post-count"
          type="number"
          min={1}
          max={50}
          value={count}
          onChange={(e) => setCount(Math.max(1, Math.min(50, Number(e.target.value))))}
          disabled={disabled}
          className="w-20 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-900 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 dark:border-dark-500 dark:bg-dark-800 dark:text-white disabled:opacity-50"
        />
      </div>

      <Button color="primary" onClick={() => onGenerate(count)} disabled={disabled}>
        {isStarting ? 'Starting…' : isGenerating ? 'Generating…' : 'Generate Posts'}
      </Button>

      {error && <p className="text-sm text-red-600 dark:text-red-400">{error}</p>}
    </div>
  );
}
